import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const DeclineFamilyEnrollmentMutation = graphql.persisted(
  "DeclineFamilyEnrollment",
  graphql(`
    mutation DeclineFamilyEnrollment($familyEnrollmentId: ID!) {
      declineFamilyEnrollment(input: {familyEnrollmentId: $familyEnrollmentId}) {
        familyEnrollment { id state }
        userErrors { message path }
      }
    }
  `)
);

export { DeclineFamilyEnrollmentMutation };

export function useDeclineFamilyEnrollment() {
  return useMutation(DeclineFamilyEnrollmentMutation);
}
